import api from "./Api";

class KitService {
  GetKit(payload) {
    return api.get("/v1/kit/" + payload).then((response) => {
      return response.data;
    });
  }

  PostKit(payload) {
    return api.post("/v1/kit/", payload).then((response) => {
      return response.data;
    });
  }

  PutKit(payload) {
    return api.put("/v1/kit/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteKit(payload) {
    return api.delete("/v1/kit/" + payload).then((response) => {
      return response.data;
    });
  }

  GetKitOData(payload) {
    return api.get("/OData/Kit" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new KitService();
